import { gql } from '@apollo/client';

export enum MfaType {
  Totp = 'TOTP',
  Email = 'EMAIL'
}

export const DeletePersonMfa = gql`
  mutation DeletePersonMfa($immutableId: String!, $mfaType: MfaType!) {
    deletePersonMfa(immutableId: $immutableId, mfaType: $mfaType)
  }
`;
